import { BaseEntity } from "yt-ng-framework";

export class FinDokumentStavka extends BaseEntity{
    constructor(){
        super();
    }    

    FinDokumentID: number = null;
    KontoID: number = null;
    KomitentID: number = null;
    Brfak: string = null;
    Datfak: Date = null;
    Datdpo: Date = null;
    Opis: string = null;
    Veza: number = null;
    OstatZatv: number = null;
    Duguje: number = null;
    Potrazuje: number = null;
    DDuguje: number = null;
    DPotrazuje: number = null;
    ValutaID: number = null;
    OrgJedID: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.FinDokumentID=input.FinDokumentID;
        this.KontoID=input.KontoID;
        this.KomitentID=input.KomitentID;
        this.Brfak=input.Brfak;
        this.Datfak=input.Datfak;
        this.Datdpo=input.Datdpo;
        this.Opis=input.Opis;
        this.Veza=input.Veza;
        this.OstatZatv=input.OstatZatv;
        this.Duguje=input.Duguje;
        this.Potrazuje=input.Potrazuje;
        this.DDuguje=input.DDuguje;
        this.DPotrazuje=input.DPotrazuje;
        this.ValutaID=input.ValutaID;
        this.OrgJedID = input.OrgJedID;
        return this;
    }

    Serialize(input:FinDokumentStavka){
        return input;
    }
}